import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Resets scroll position on navigation, which client-side routing doesn't do. */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  return null;
};
